import * as types from "../types";

const initialState = {
    loading: false,
    reqKey: null,
    resFeature: null,
    error: null
}

export default function fetchFeatureSettingReducer(state = initialState, action){

    switch(action.type){
        case types.FETCH_FEATURE_SETTING_REQUEST:
            return {
                ...state,
                loading: true,
                reqKey: action.payload.reqKey
            }

        case types.FETCH_FEATURE_SETTING_SUCCESS:
            return {
                ...state,
                loading: false,
                resFeature: action.payload.resFeature
            }

        case types.FETCH_FEATURE_SETTING_FAILURE:
            return {
                ...state,
                loading: false,
                reqKey: null,
                resFeature: null,
                error: action.payload.error
            }

        default :
        return state
    }

}